import { CreateTagDto, DeleteTagDto, FindTagsQueryDto, FindTagsResponse } from '@/@types/theoryGit/tags';
import { GitApiAxiosBase } from '@/repository/base/axiosBase';

export class TagsRepository {
  private readonly requestBasePath = 'v1/tags';
  private readonly axios = new GitApiAxiosBase();
  /**タグ登録 */
  async createTag(repositoryInfoId: number, params: CreateTagDto) {
    const endPoint = `${this.requestBasePath}/${repositoryInfoId}`;
    await this.axios.post(endPoint, params);
  }

  /**タグ一覧取得 */
  async findTags(repositoryInfoId: number, query: FindTagsQueryDto) {
    const endPoint = `${this.requestBasePath}/${repositoryInfoId}`;
    const response = await this.axios.get<FindTagsResponse>(
      endPoint,
      { params: query },
    );
    return response.data;
  }

  /**タグ削除 */
  async deleteTag(params: DeleteTagDto) {
    await this.axios.post(this.requestBasePath, params);
  }
}
